"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = _interopRequireDefault(require("../../svg"));

var _desktopUserNav = require("./desktop-user-nav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UserPopover = function UserPopover(_ref) {
  var activeLink = _ref.activeLink,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes;
  var signedInRoutes = routes === null || routes === void 0 ? void 0 : routes.filter(function (route) {
    return (route === null || route === void 0 ? void 0 : route.type) === 'signed-in';
  });
  return (routes === null || routes === void 0 ? void 0 : routes.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_desktopUserNav.UserLinksWrapper, null, /*#__PURE__*/_react["default"].createElement("ul", {
    role: "list"
  }, signedInRoutes === null || signedInRoutes === void 0 ? void 0 : signedInRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: route === null || route === void 0 ? void 0 : route.url
    }, /*#__PURE__*/_react["default"].createElement(_desktopUserNav.NavLink, {
      href: route === null || route === void 0 ? void 0 : route.url,
      active: activeLink === (route === null || route === void 0 ? void 0 : route.url)
    }, route !== null && route !== void 0 && route.icon ? /*#__PURE__*/_react["default"].createElement(_svg["default"], {
      id: route.icon,
      stroke: "inherit",
      fill: "inherit",
      height: "16px",
      width: "16px",
      SVGWrapper: _desktopUserNav.SVGWrapper
    }) : null, route === null || route === void 0 ? void 0 : route.text));
  }))) : null;
};

UserPopover.propTypes = {
  activeLink: _propTypes["default"].string,
  routes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].string,
    text: _propTypes["default"].string,
    type: _propTypes["default"].string,
    url: _propTypes["default"].string
  }))
};
var _default = UserPopover;
exports["default"] = _default;